import {
  CHECKOUT_EXTENSION_PATH,
  CHECKOUT_REFRESH_PROTOCOL,
  isRefreshMessage,
} from "@redotech/redo-bigcommerce-checkout-extension/protocol";

const extensionOrigin = "https://bigcommerce-checkout-extension.getredo.com";
let pending: Promise<boolean> | undefined;

export function isBigcommerceCheckout() {
  return (
    globalThis.redoStorefront?.type === "bigcommerce" &&
    location.pathname.includes("/checkout")
  );
}

/** True means SDK dispatch, false means timeout. */
export function refreshCheckout(): Promise<boolean> {
  if (pending) {
    return pending;
  }
  pending = new Promise<boolean>((resolve) => {
    const requestId = crypto.randomUUID();
    const frames = () =>
      Array.from(document.querySelectorAll("iframe")).filter((frame) => {
        const url = new URL(frame.src, location.href);
        return (
          url.origin === extensionOrigin &&
          url.pathname === CHECKOUT_EXTENSION_PATH
        );
      });
    const finish = (success: boolean) => {
      clearInterval(interval);
      clearTimeout(timeout);
      window.removeEventListener("message", onMessage);
      resolve(success);
    };
    const onMessage = (event: MessageEvent<unknown>) => {
      if (
        event.origin !== extensionOrigin ||
        !isRefreshMessage(event.data) ||
        event.data.type !== "dispatched" ||
        event.data.requestId !== requestId ||
        !frames().some((frame) => frame.contentWindow === event.source)
      ) {
        return;
      }
      finish(true);
    };
    const send = () => {
      for (const frame of frames()) {
        if (frame.contentWindow) {
          frame.contentWindow.postMessage(
            { protocol: CHECKOUT_REFRESH_PROTOCOL, type: "refresh", requestId },
            extensionOrigin,
          );
        }
      }
    };
    window.addEventListener("message", onMessage);
    const interval = setInterval(send, 100);
    const timeout = setTimeout(() => finish(false), 2000);
    send();
  }).finally(() => {
    pending = undefined;
  });
  return pending;
}
